// Spread onto a non-button element that acts as a button (a clickable card,
// row or list item) so keyboard users can reach it with Tab and press it with
// Enter or Space (WCAG 2.1.1). Prefer a real <button> or <Link> where the
// markup allows; this is for blocks a button can't wrap cleanly.
//
//   <div {...pressable(() => open(row))} className="...">
//
// Keys pressed inside a nested input or button are left alone.
export function pressable(onActivate, label) {
  return {
    role: "button",
    tabIndex: 0,
    onClick: onActivate,
    onKeyDown: (e) => {
      if (e.target !== e.currentTarget) return;
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onActivate(e);
      }
    },
    ...(label ? { "aria-label": label } : {}),
  };
}
